type Theme = 'light' | 'dark'; // Immediately set initial theme to prevent flickering

const storageKey = 'theme';
const storedTheme = localStorage.getItem(storageKey);
const theme = storedTheme === 'dark' ? 'dark' : 'light';
document.documentElement.setAttribute('data-theme', theme);

class ThemeToggle {
  private readonly storageKey: string;
  private readonly lightClass: string;
  private readonly darkClass: string;
  private readonly htmlElement: HTMLElement;

  constructor() {
    this.storageKey = 'theme';
    this.lightClass = 'light-theme';
    this.darkClass = 'dark-theme';
    this.htmlElement = document.documentElement;

    this.initializeTheme();
    this.setupEventListeners();
  }

  private initializeTheme(): void {
    const storedTheme = localStorage.getItem(this.storageKey);
    const theme = (storedTheme === 'dark' ? 'dark' : 'light') as Theme;
    this.setTheme(theme);
  }

  private setupEventListeners(): void {
    const toggleButtons = document.querySelectorAll('[x-theme-toggle]');
    toggleButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const currentTheme = this.htmlElement.getAttribute(
          'data-theme',
        ) as Theme;
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
        this.setTheme(newTheme);
        localStorage.setItem(this.storageKey, newTheme);
        e.preventDefault();
      });
    });
  }

  private setTheme(theme: Theme): void {
    this.htmlElement.setAttribute('data-theme', theme);
    if (theme === 'dark') {
      document.body.classList.add(this.darkClass);
      document.body.classList.remove(this.lightClass);
    } else {
      document.body.classList.add(this.lightClass);
      document.body.classList.remove(this.darkClass);
    }
  }

  public toggle(): void {
    const currentTheme = this.htmlElement.getAttribute('data-theme') as Theme;
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    this.setTheme(newTheme);
    localStorage.setItem(this.storageKey, newTheme);
  }
}

// Initialize theme toggle when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ThemeToggle();
});
